import IDUtils from "../utils/IDUtils";
import _ from "lodash";

import AppConstants from "../constants/AppConstants";
import { ensureArray } from "../utils/JSUtils";

/**
 * @typedef {import("@/constants/PropUpdateConstants.mjs").SPLIT} SPLIT
 * @typedef {import("@/constants/PropUpdateConstants.mjs").MERGE} MERGE
 * 
 * @typedef {Object} PropUpdate
 * @prop {string=} name - path to property using dot notation
 * @prop {*=} value - the value to be set
 * @prop {("set"|"delete"|"merge")=} action - how to handle value setting with previous value in mind
 * @prop {boolean=} addUndo - flag to add an undo/redo point on the stack
 * @prop {*=} origValue - previous value. Useful for color.
 * @prop {*=} source - ???
 * @prop {(SPLIT|MERGE)=} intent - flag to indicate intent of the update
 */

class BlockUpdate {
  constructor() {
    this.id = null; //block id
    this.updates = [];
  }

  addPropUpdate(id, propInfo) {
    var name = _.get(propInfo, "name", false);
    var value = _.get(propInfo, "value");
    var action = _.get(propInfo, "action", false);
    const addUndo = _.get(propInfo, "addUndo", false);
    const source = _.get(propInfo, "source");

    if (name) {
      var pathParts = name.split(".");
      this.add(id, pathParts, value, action, addUndo, source);
    }
  }

  add(id, propPath, value, updateAction, addUndo, source) {
    var path = IDUtils.getArray(id);
    var action = false;

    //allow normal update action to be overwritten
    if (updateAction) {
      action = updateAction;
    }

    //block id not set figure it out from id that was passed
    if (this.id == null) {
      this.id = path[0]; //first element should be block id
    }

    if (path.length == 1) {
      //means this was the block itself
      path = [];
    } else {
      path.shift();
    }

    //handle block state properties
    if (propPath.length > 3 && propPath[1] == "states") {
      propPath.shift();
    }

    var update = {
      key: path.concat(propPath),
      value,
      action,
      addUndo,
      source,
    };

    this.updates.push(update);
  }

  deleteProp(id, propPath) {
    return this.add(id, propPath, null, AppConstants.UPDATE_ACTION_DELETE);
  }

  reset(id, propPath, updateAction) {
    if (updateAction) return this.add(id, propPath, null, updateAction);
    else return this.add(id, propPath, null, AppConstants.UPDATE_ACTION_SET);
  }

  /**
   *
   * @param {PropUpdate | Array<PropUpdate>} propInfo
   * @returns {Boolean}
   */
  updatesHaveUndo(propInfo) {
    return ensureArray(propInfo).some(({ addUndo }) => addUndo);
  }

  /**
   * Collapses undo point onto the first update to give a set of updates a single undo point.
   * @param {boolean} hasUndo
   * @returns
   */
  collapseUndos(hasUndo = this.updatesHaveUndo(this.updates)) {
    this.updates = ensureArray(this.updates).map((update, i) => ({
      ...update,
      addUndo: i || !hasUndo ? false : true,
    }));
  }
}

export default BlockUpdate;
